"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.stringifyLinesOfCoverage = void 0;
function stringifyLinesOfCoverage(linesOfCoverage) {
    return (linesOfCoverage
        .map(function (loc) { var _a; return "" + ((_a = loc.definition) === null || _a === void 0 ? void 0 : _a.readableName) + (loc.displayName ? " - " + loc.displayName : ''); })
        .join(', ') || '-');
}
exports.stringifyLinesOfCoverage = stringifyLinesOfCoverage;
